var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLivehood(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 32,
    viewBox: "0 0 44 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26 18C24.3333 18 22.9167 17.4167 21.75 16.25C20.5833 15.0833 20 13.6667 20 12C20 10.3333 20.5833 8.91667 21.75 7.75C22.9167 6.58333 24.3333 6 26 6C27.6667 6 29.0833 6.58333 30.25 7.75C31.4167 8.91667 32 10.3333 32 12C32 13.6667 31.4167 15.0833 30.25 16.25C29.0833 17.4167 27.6667 18 26 18V18M12 24C10.9 24 9.95833 23.6083 9.175 22.825C8.39167 22.0417 8 21.1 8 20V4C8 2.9 8.39167 1.95833 9.175 1.175C9.95833 0.391667 10.9 0 12 0H40C41.1 0 42.0417 0.391667 42.825 1.175C43.6083 1.95833 44 2.9 44 4V20C44 21.1 43.6083 22.0417 42.825 22.825C42.0417 23.6083 41.1 24 40 24H12V24M16 20H36C36 18.9 36.3917 17.9583 37.175 17.175C37.9583 16.3917 38.9 16 40 16V8C38.9 8 37.9583 7.60833 37.175 6.825C36.3917 6.04167 36 5.1 36 4H16C16 5.1 15.6083 6.04167 14.825 6.825C14.0417 7.60833 13.1 8 12 8V16C13.1 16 14.0417 16.3917 14.825 17.175C15.6083 17.9583 16 18.9 16 20V20M38 32H4C2.9 32 1.95833 31.6083 1.175 30.825C0.391667 30.0417 0 29.1 0 28V6H4V28V28V28H38V32V32M12 20V20V20V20V4V4V4V4V4V4V20V20V20V20",
    fill: "#FDC82A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLivehood);
export default __webpack_public_path__ + "static/media/livehood.975c45eda83f300cdfda139169da3db3.svg";
export { ForwardRef as ReactComponent };